import React, { useEffect } from "react";
import "../assets/css/cxda.css";
import "aos/dist/aos.css";
import AOS from "aos";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaPhoneAlt, FaEnvelope, FaGlobe } from "react-icons/fa";

const ContactSection = () => {
     useEffect(() => {
            AOS.init({ duration: 1000 });
          }, []);
  return (
    <div className="contact-section container-fluid py-5" data-aos="fade-up">
      <div className="text-center mb-5">
       
        <h6 className="contact-title ">Contact Us</h6>
      </div>

      <div className="container">
        <div className="row g-4 justify-content-center">
          {/* 📞 Phone Card */}
          <div className="col-md-4">
            <div className="contact-card card shadow-sm border-0 h-100">
              <div className="card-body text-center">
                <FaPhoneAlt className="contact-icon" />
                <h5 className="fw-bold mb-3 text-dark">Phone</h5>
                <p className="mb-1 text-secondary">(+968) 771 37 555</p>
                <p className="mb-0 text-secondary">(+968) 9575 6811</p>
              </div>
            </div>
          </div>

          {/* ✉️ Email Card */}
          <div className="col-md-4">
            <div className="contact-card card shadow-sm border-0 h-100">
              <div className="card-body text-center">
                <FaEnvelope className="contact-icon" />
                <h5 className="fw-bold mb-3 text-dark">Email</h5>
                <p className="mb-1 text-secondary">bharat@cxda.om</p>
                <p className="mb-0 text-secondary">ammarbalushi@cxda.om</p>
              </div>
            </div>
          </div>

          {/* 🌍 Address Card */}
          <div className="col-md-4">
            <div className="contact-card card shadow-sm border-0 h-100">
              <div className="card-body text-center">
                <FaGlobe className="contact-icon" />
                <h5 className="fw-bold mb-3 text-dark">Address</h5>
                <p className="text-secondary mb-0">
                  Office No. 204, 2<sup>nd</sup> Floor, Al Assalah Towers,
                  South Ghubrah Muscat, Oman
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSection;
